/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface EntitiesActivityGraphDataPoint {
    assessments?: number;
    courses?: number;
    date?: string;
    interviews?: number;
}

export interface EntitiesChangePasswordRequest {
    password_hash?: string;
}

export interface EntitiesConversationAskQuestionRequest {
    question?: string;
    subtopic?: string;
    topic?: string;
}

export interface EntitiesConversationAskQuestionResponse {
    response?: string;
}

export interface EntitiesConversationGenerateExampleRequest {
    subtopic?: string;
    topic?: string;
}

export interface EntitiesConversationGenerateExampleResponse {
    example?: string;
}

export interface EntitiesCreateAssessmentRequest {
    assessmentTypeID?: string;
    category?: string;
    description?: string;
    interactionType?: ModelAssessmentInteractionType;
    skill?: string;
    topic?: string;
    totalQuestions?: number;
    totalTimeMinutes?: number;
}

export interface EntitiesCreateAssessmentResponse {
    assessment?: ModelAssessment;
}

export interface EntitiesDescribeResponse {
    output?: string;
}

export interface EntitiesError {
    message?: string;
}

export enum EntitiesFieldsToUpdate {
    FieldsToUpdateProfile = 'profile',
    FieldsToUpdateEducation = 'education',
    FieldsToUpdateExperiences = 'experiences',
    FieldsToUpdateProjects = 'projects',
    FieldsToUpdateJobPreference = 'job_preference',
    FieldsToUpdateCertificates = 'certificates',
}

export interface EntitiesGetActivityGraphResponse {
    dataPoints?: EntitiesActivityGraphDataPoint[];
}

export interface EntitiesGetAssessmentActivitiesResponse {
    totalCreated?: number;
    totalFailed?: number;
    totalNotStarted?: number;
    totalSuccessful?: number;
    totalUnfinished?: number;
}

export interface EntitiesGetAssessmentsResponse {
    assessment?: ModelAssessment;
}

export interface EntitiesGetBalanceResponse {
    balance?: number;
    balanceInAverageAssessment?: number;
    balanceInAverageCourse?: number;
    balanceInVoiceSeconds?: number;
}

export interface EntitiesGetBillingSettingsResponse {
    monthlyUsageLimit?: number;
    notificationEmail?: string;
    payerName?: string;
    payerPhoneNo?: string;
}

export interface EntitiesGetCourseActivitiesResponse {
    totalCreated?: number;
    totalFinished?: number;
    totalNotStarted?: number;
    totalUnfinished?: number;
}

export interface EntitiesGetInterviewActivitiesResponse {
    totalCreated?: number;
    totalFailed?: number;
    totalSuccessful?: number;
}

export interface EntitiesGetMeResponse {
    user?: ModelUser;
}

export interface EntitiesGetSkillScoreGraphResponse {
    datapoints?: EntitiesSkillScoreGraphDataPoint[];
}

export interface EntitiesJobsResponse {
    jobs?: ModelJob[];
}

export interface EntitiesListAssessmentTypesResponse {
    assessment_types?: ModelAssessmentType[];
}

export interface EntitiesListAssessmentsResponse {
    assessments?: ModelAssessment[];
}

export interface EntitiesListRunningCoursesResponse {
    courses?: ModelTrainingCourse[];
}

export interface EntitiesListTrainingCoursesResponse {
    courses?: ModelUserTrainingCourse[];
}

export interface EntitiesListTransactionsResponse {
    transactions?: ModelTransaction[];
}

export interface EntitiesLoginByResumeResponse {
    shouldLogin?: boolean;
    token?: string;
}

export interface EntitiesRequestMessage {
    subscribeToTrainingConversation?: EntitiesSubscribeToTrainingConversation;
}

export interface EntitiesRespondToAssessmentTextRequest {
    response?: string;
}

export interface EntitiesResponseMessage {
    error?: EntitiesError;
    trainingConversationGenerationFinished?: EntitiesTrainingConversationGenerationFinished;
    trainingMessage?: EntitiesTrainingMessage;
}

export interface EntitiesSignUpEmailRequest {
    email?: string;
}

export interface EntitiesSignUpPasswordRequest {
    password_hash?: string;
    token?: string;
}

export interface EntitiesSkillBasedOnDescriptionRequest {
    description?: string;
}

export interface EntitiesSkillBasedOnDescriptionResponse {
    suggestedSkills?: string[];
}

export interface EntitiesSkillScoreGraphDataPoint {
    date?: string;
    score?: number;
    skill?: string;
}

export interface EntitiesStartTrainingCourseRequest {
    category?: string;
    description?: string;
    skill?: string;
    topic?: string;
    totalQuestions?: number;
}

export interface EntitiesStartTrainingCourseResponse {
    course?: ModelTrainingCourse;
}

export interface EntitiesSubscribeToTrainingConversation {
    courseID?: number;
    subtopic?: string;
    topic?: string;
}

export interface EntitiesSuggestNewCertificatesResponse {
    suggestedCertificates?: string[];
}

export interface EntitiesSuggestNewSkillsResponse {
    suggestedSkills?: string[];
}

export interface EntitiesTTSRequest {
    inputText?: string;
}

export interface EntitiesTrainingConversationGenerationFinished {
    finished?: boolean;
}

export interface EntitiesTrainingMessage {
    avatar?: string;
    avatar_id?: string;
    avatar_run_status?: PlatformPkgAiDIdTalkStatus;
    created_at?: number;
    id?: string;
    message?: string;
    new_message?: ModelMessageStructure;
    role?: string;
    voiceFile?: string;
    voiceLengthSeconds?: number;
}

export interface EntitiesUpdateBillingSettingsRequest {
    monthlyUsageLimit?: number;
    notificationEmail?: string;
    payerName?: string;
    payerPhoneNo?: string;
}

export interface EntitiesUpdateMeRequest {
    certificates?: ModelCertificate[];
    education?: ModelEducation[];
    experiences?: ModelExperience[];
    fieldsToUpdate?: EntitiesFieldsToUpdate[];
    jobPreference?: ModelJobPreference;
    profile?: ModelUserProfile;
    projects?: ModelProject[];
}

export interface GormDeletedAt {
    time?: string;
    /** Valid is true if Time is not NULL */
    valid?: boolean;
}

export interface ModelAssessment {
    assessmentTypeID?: string;
    category?: string;
    conversation?: ModelConversation;
    createdAt?: string;
    description?: string;
    id?: number;
    interactionType?: ModelAssessmentInteractionType;
    isCancelled?: boolean;
    report?: ModelReportStructure;
    reportMessage?: string;
    skill?: string;
    topic?: string;
    totalQuestions?: number;
    totalTimeMinutes?: number;
    totalPassedMinutes?: number;
    updatedAt?: string;
    userId?: string;
}

export enum ModelAssessmentInteractionType {
    AssessmentInteractionTypeText = 'text',
    AssessmentInteractionTypeVoice = 'voice',
    AssessmentInteractionTypeVideo = 'video',
}

export interface ModelAssessmentType {
    category?: string;
    description?: string;
    durationMinutes?: number;
    id?: string;
    skill?: string;
    title?: string;
    totalQuestions?: number;
}

export interface ModelCertificate {
    courseName?: string;
    endMonth?: string;
    endYear?: string;
    instituteName?: string;
    logo?: string;
    startMonth?: string;
    startYear?: string;
}

export interface ModelConversation {
    messages?: ModelMessage[];
}

export interface ModelEducation {
    degree?: string;
    description?: string;
    endMonth?: string;
    endYear?: string;
    field?: string;
    logo?: string;
    repetitive?: boolean;
    startMonth?: string;
    startYear?: string;
    university?: string;
}

export interface ModelExperience {
    companyName?: string;
    description?: string;
    endMonth?: string;
    endYear?: string;
    jobTitle?: string;
    location?: string;
    postcode?: string;
    repetitive?: boolean;
    startMonth?: string;
    startYear?: string;
}

export interface ModelInterviewType {
    description?: string;
    durationMinutes?: number;
    id?: string;
    totalQuestions?: number;
}

export interface ModelJob {
    createdAt?: string;
    failureReason?: string;
    id?: number;
    jobType?: ModelJobType;
    maxRetries?: number;
    retryCount?: number;
    status?: ModelStatus;
    updatedAt?: string;
    userID?: string;
}

export interface ModelJobPreference {
    authorized?: string;
    commitment?: string;
    countries?: string[];
    englishProficiency?: string;
    sponsorship?: string;
    startingTime?: string;
}

export enum ModelJobType {
    JobTypeUpdateInterviewTypes = 'UpdateInterviewTypes',
    JobTypeUpdateAssessmentTypes = 'UpdateAssessmentTypes',
    JobTypeUpdateTrainingCourses = 'UpdateTrainingCourses',
}

export interface ModelMessage {
    avatar?: string;
    avatar_id?: string;
    avatar_run_status?: PlatformPkgAiDIdTalkStatus;
    created_at?: number;
    id?: string;
    message?: string;
    new_message?: ModelMessageStructure;
    role?: string;
    voiceFile?: string;
    voiceLengthSeconds?: number;
}

export interface ModelMessageStructure {
    choices?: string[];
    question?: string;
    question_number?: number;
    question_type?: ModelQuestionType;
    total_question_count?: number;
}

export interface ModelProject {
    description?: string;
    endMonth?: string;
    endYear?: string;
    image1?: string;
    image2?: string;
    image3?: string;
    logo?: string;
    projectName?: string;
    projectUrl?: string;
    repetitive?: boolean;
    role?: string;
    sourceCodeUrl?: string;
    startMonth?: string;
    startYear?: string;
}

export enum ModelQuestionType {
    QuestionTypeMultipleChoice = 'multiple_choice',
    QuestionTypeSingleChoice = 'single_choice',
    QuestionTypeDescriptive = 'descriptive',
}

export interface ModelReportStructure {
    ImprovementAreas?: {
        Score?: number;
        Skill?: string;
    }[];
    NextSteps?: string[];
    Overview?: {
        AssessmentPurpose?: string;
        Scope?: string;
    };
    PerformanceSummary?: {
        CompletionTime?: string;
        SummaryOfAssessment?: string;
        TotalScore?: number;
    };
    Recommendations?: {
        Skill?: string;
        SuggestedResources?: string[];
    }[];
    SkillBreakdown?: {
        CoreSkillsEvaluated?: {
            Score?: number;
            Skill?: string;
        }[];
    };
    Strengths?: string[];
}

export enum ModelSkillCategory {
    SkillCategoryTECHNICAL = 'TECHNICAL',
    SkillCategorySOFTSKILL = 'SOFTSKILL',
    SkillCategoryLANGUAGE = 'LANGUAGE',
}

export enum ModelStatus {
    StatusCREATED = 'CREATED',
    StatusINPROGRESS = 'IN_PROGRESS',
    StatusSUCCEEDED = 'SUCCEEDED',
    StatusFAILED = 'FAILED',
}

export interface ModelSubTopic {
    conversation?: ModelConversation;
    generationFinished?: boolean;
    title?: string;
}

export interface ModelTopic {
    subTopics?: ModelSubTopic[];
    title?: string;
}

export interface ModelTrainingCourse {
    category?: string;
    createdAt?: string;
    description?: string;
    id?: number;
    skill?: string;
    title?: string;
    topic?: ModelTopic[];
    totalQuestions?: number;
    updatedAt?: string;
    userId?: string;
}

export interface ModelTransaction {
    amount?: number;
    createdAt?: string;
    deletedAt?: GormDeletedAt;
    details?: ModelTransactionDetails;
    id?: number;
    type?: ModelTransactionType;
    updatedAt?: string;
    userId?: string;
}

export interface ModelTransactionDetails {
    imageSize?: string;
    textGeneration?: OpenaiUsage;
    textToSpeechLength?: number;
    voiceSeconds?: number;
}

export enum ModelTransactionType {
    TransactionTypeCharge = 'CHARGE',
    TransactionTypeAIUSAGE = 'AI_USAGE',
}

export interface ModelUser {
    createdAt?: string;
    details?: ModelUserDetails;
    id?: string;
    isCompany?: boolean;
    updatedAt?: string;
}

export interface ModelUserDetails {
    assessmentTypes?: ModelAssessmentType[];
    certificates?: ModelCertificate[];
    courses?: ModelUserTrainingCourse[];
    education?: ModelEducation[];
    experiences?: ModelExperience[];
    interviewTypes?: ModelInterviewType[];
    jobPreference?: ModelJobPreference;
    profile?: ModelUserProfile;
    projects?: ModelProject[];
}

export interface ModelUserProfile {
    availability?: string;
    description?: string;
    email?: string;
    englishProficiency?: string;
    firstName?: string;
    lastName?: string;
    overallExp?: string;
    phoneNumber?: string;
    profileGitHub?: string;
    profileImage?: string;
    profileLinkedIn?: string;
    profilePortfolio?: string;
    profileTwitter?: string;
    remoteExp?: string;
    role?: string;
    seniority?: string;
    skills?: string[];
    verifiedSkills?: ModelVerifiedSkill[];
}

export interface ModelUserTrainingCourse {
    category?: string;
    description?: string;
    skill?: string;
    title?: string;
    totalQuestions?: number;
}

export interface ModelVerifiedSkill {
    category?: ModelSkillCategory;
    iconURL?: string;
    summaryOfLastAssessment?: string;
    title?: string;
    /** out of 100 */
    userScore?: number;
}

export interface OpenaiUsage {
    completion_tokens?: number;
    prompt_tokens?: number;
    total_tokens?: number;
}

export enum PlatformPkgAiDIdTalkStatus {
    TalkStatusCreated = 'created',
    TalkStatusDone = 'done',
    TalkStatusError = 'error',
    TalkStatusStarted = 'started',
    TalkStatusRejected = 'rejected',
}

import axios, {
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
    HeadersDefaults,
    ResponseType,
} from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
    extends Omit<
        AxiosRequestConfig,
        'data' | 'params' | 'url' | 'responseType'
    > {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType;
    /** request body */
    body?: unknown;
}

export type RequestParams = Omit<
    FullRequestParams,
    'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
    extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
    secure?: boolean;
    format?: ResponseType;
}

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public instance: AxiosInstance;
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private secure?: boolean;
    private format?: ResponseType;

    constructor({
        securityWorker,
        secure,
        format,
        ...axiosConfig
    }: ApiConfig<SecurityDataType> = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || 'https://http://dev.reqter.com/',
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected mergeRequestParams(
        params1: AxiosRequestConfig,
        params2?: AxiosRequestConfig
    ): AxiosRequestConfig {
        const method = params1.method || (params2 && params2.method);

        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method &&
                    this.instance.defaults.headers[
                        method.toLowerCase() as keyof HeadersDefaults
                    ]) ||
                    {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        } else {
            return `${formItem}`;
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent: any[] =
                property instanceof Array ? property : [property];

            for (const formItem of propertyContent) {
                const isFileType =
                    formItem instanceof Blob || formItem instanceof File;
                formData.append(
                    key,
                    isFileType ? formItem : this.stringifyFormItem(formItem)
                );
            }

            return formData;
        }, new FormData());
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;

        if (
            type === ContentType.FormData &&
            body &&
            body !== null &&
            typeof body === 'object'
        ) {
            body = this.createFormData(body as Record<string, unknown>);
        }

        if (
            type === ContentType.Text &&
            body &&
            body !== null &&
            typeof body !== 'string'
        ) {
            body = JSON.stringify(body);
        }

        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type ? { 'Content-Type': type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}

/**
 * @title Platform API
 * @version 1.0
 * @baseUrl https://http://dev.reqter.com/
 * @contact
 */
export class Api<
    SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
    api = {
        /**
         * No description
         *
         * @tags billing
         * @name V1ActivityAssessmentList
         * @summary returns user activities on assessment
         * @request GET:/api/v1/activity/assessment
         */
        v1ActivityAssessmentList: (params: RequestParams = {}) =>
            this.request<EntitiesGetAssessmentActivitiesResponse, any>({
                path: `/api/v1/activity/assessment`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1ActivityCourseList
         * @summary returns user activities on courses
         * @request GET:/api/v1/activity/course
         */
        v1ActivityCourseList: (params: RequestParams = {}) =>
            this.request<EntitiesGetCourseActivitiesResponse, any>({
                path: `/api/v1/activity/course`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1ActivityGraphList
         * @summary returns graph of user activities
         * @request GET:/api/v1/activity/graph
         */
        v1ActivityGraphList: (params: RequestParams = {}) =>
            this.request<EntitiesGetActivityGraphResponse, any>({
                path: `/api/v1/activity/graph`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1ActivityInterviewList
         * @summary returns user activities on interviews
         * @request GET:/api/v1/activity/interview
         */
        v1ActivityInterviewList: (params: RequestParams = {}) =>
            this.request<EntitiesGetInterviewActivitiesResponse, any>({
                path: `/api/v1/activity/interview`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1AssessmentList
         * @summary ListAssessments
         * @request GET:/api/v1/assessment
         */
        v1AssessmentList: (params: RequestParams = {}) =>
            this.request<EntitiesListAssessmentsResponse, any>({
                path: `/api/v1/assessment`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1AssessmentCreate
         * @summary CreateAssessment
         * @request POST:/api/v1/assessment
         */
        v1AssessmentCreate: (
            request: EntitiesCreateAssessmentRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesCreateAssessmentResponse, any>({
                path: `/api/v1/assessment`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1AssessmentTypesList
         * @summary ListAssessmentTypes
         * @request GET:/api/v1/assessment/types
         */
        v1AssessmentTypesList: (params: RequestParams = {}) =>
            this.request<EntitiesListAssessmentTypesResponse, any>({
                path: `/api/v1/assessment/types`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1AssessmentDetail
         * @summary GetAssessment
         * @request GET:/api/v1/assessment/{assessmentId}
         */
        v1AssessmentDetail: (
            assessmentId: number,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesGetAssessmentsResponse, any>({
                path: `/api/v1/assessment/${assessmentId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1AssessmentDelete
         * @summary CancelAssessment
         * @request DELETE:/api/v1/assessment/{assessmentId}
         */
        v1AssessmentDelete: (
            assessmentId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/assessment/${assessmentId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1AssessmentRespondTextCreate
         * @summary RespondToAssessmentText
         * @request POST:/api/v1/assessment/{assessmentId}/respond/text
         */
        v1AssessmentRespondTextCreate: (
            assessmentId: number,
            request: EntitiesRespondToAssessmentTextRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/assessment/${assessmentId}/respond/text`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1AssessmentRespondVoiceCreate
         * @summary RespondToAssessmentVoice
         * @request POST:/api/v1/assessment/{assessmentId}/respond/voice
         */
        v1AssessmentRespondVoiceCreate: (
            assessmentId: number,
            data: {
                /** The response voice file */
                'voice-response': File;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/assessment/${assessmentId}/respond/voice`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1BillingBalanceList
         * @summary returns user balance
         * @request GET:/api/v1/billing/balance
         */
        v1BillingBalanceList: (params: RequestParams = {}) =>
            this.request<EntitiesGetBalanceResponse, any>({
                path: `/api/v1/billing/balance`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1BillingSettingsList
         * @summary get billing settings
         * @request GET:/api/v1/billing/settings
         */
        v1BillingSettingsList: (params: RequestParams = {}) =>
            this.request<EntitiesGetBillingSettingsResponse, any>({
                path: `/api/v1/billing/settings`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1BillingSettingsCreate
         * @summary update billing settings
         * @request POST:/api/v1/billing/settings
         */
        v1BillingSettingsCreate: (
            request: EntitiesUpdateBillingSettingsRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/billing/settings`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1BillingTransactionsList
         * @summary lists transactions
         * @request GET:/api/v1/billing/transactions
         */
        v1BillingTransactionsList: (params: RequestParams = {}) =>
            this.request<EntitiesListTransactionsResponse, any>({
                path: `/api/v1/billing/transactions`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1CourseList
         * @summary ListTrainingCourses
         * @request GET:/api/v1/course
         */
        v1CourseList: (params: RequestParams = {}) =>
            this.request<EntitiesListTrainingCoursesResponse, any>({
                path: `/api/v1/course`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1CourseCreate
         * @summary StartTrainingCourses
         * @request POST:/api/v1/course
         */
        v1CourseCreate: (
            request: EntitiesStartTrainingCourseRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesStartTrainingCourseResponse, any>({
                path: `/api/v1/course`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1CourseListList
         * @summary ListRunningCourses
         * @request GET:/api/v1/course/list
         */
        v1CourseListList: (params: RequestParams = {}) =>
            this.request<EntitiesListRunningCoursesResponse, any>({
                path: `/api/v1/course/list`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1CourseConversationExampleCreate
         * @summary TrainingCoursesGenerateExample
         * @request POST:/api/v1/course/{id}/conversation/example
         */
        v1CourseConversationExampleCreate: (
            id: number,
            request: EntitiesConversationGenerateExampleRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesConversationGenerateExampleResponse, any>({
                path: `/api/v1/course/${id}/conversation/example`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1CourseConversationQuestionCreate
         * @summary TrainingCourseAskQuestion
         * @request POST:/api/v1/course/{id}/conversation/question
         */
        v1CourseConversationQuestionCreate: (
            id: number,
            request: EntitiesConversationAskQuestionRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesConversationAskQuestionResponse, any>({
                path: `/api/v1/course/${id}/conversation/question`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1JobsList
         * @summary Jobs
         * @request GET:/api/v1/jobs
         */
        v1JobsList: (params: RequestParams = {}) =>
            this.request<EntitiesJobsResponse, any>({
                path: `/api/v1/jobs`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1LoginResumeUpdate
         * @summary LoginByResume
         * @request PUT:/api/v1/login/resume
         */
        v1LoginResumeUpdate: (
            data: {
                /**
                 * The file
                 * @format binary
                 */
                file: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<EntitiesLoginByResumeResponse, any>({
                path: `/api/v1/login/resume`,
                method: 'PUT',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags profile
         * @name V1ProfileDescribeAboutMeCreate
         * @summary describe user
         * @request POST:/api/v1/profile/describe/about-me
         */
        v1ProfileDescribeAboutMeCreate: (params: RequestParams = {}) =>
            this.request<EntitiesDescribeResponse, any>({
                path: `/api/v1/profile/describe/about-me`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags profile
         * @name V1ProfileDescribeProjectsCreate
         * @summary describe user's projects
         * @request POST:/api/v1/profile/describe/projects
         */
        v1ProfileDescribeProjectsCreate: (params: RequestParams = {}) =>
            this.request<EntitiesDescribeResponse, any>({
                path: `/api/v1/profile/describe/projects`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags profile
         * @name V1ProfileDescribeWorkExperienceCreate
         * @summary describe user's work experience
         * @request POST:/api/v1/profile/describe/work-experience
         */
        v1ProfileDescribeWorkExperienceCreate: (params: RequestParams = {}) =>
            this.request<EntitiesDescribeResponse, any>({
                path: `/api/v1/profile/describe/work-experience`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1ProfileResumeUpdate
         * @summary UpdateByResume
         * @request PUT:/api/v1/profile/resume
         */
        v1ProfileResumeUpdate: (
            data: {
                /**
                 * The file
                 * @format binary
                 */
                file: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<ModelUserDetails, any>({
                path: `/api/v1/profile/resume`,
                method: 'PUT',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags profile
         * @name V1ProfileSkillsDescriptionCreate
         * @summary suggests skills for the provided description
         * @request POST:/api/v1/profile/skills/description
         */
        v1ProfileSkillsDescriptionCreate: (
            request: EntitiesSkillBasedOnDescriptionRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesSkillBasedOnDescriptionResponse, any>({
                path: `/api/v1/profile/skills/description`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags profile
         * @name V1ProfileSkillsScoreGraphList
         * @summary suggests new skills for the user to add to his list of skills
         * @request GET:/api/v1/profile/skills/score/graph
         */
        v1ProfileSkillsScoreGraphList: (params: RequestParams = {}) =>
            this.request<EntitiesGetSkillScoreGraphResponse, any>({
                path: `/api/v1/profile/skills/score/graph`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags profile
         * @name V1ProfileSkillsSuggestCreate
         * @summary suggests new skills for the user to add to his list of skills
         * @request POST:/api/v1/profile/skills/suggest
         */
        v1ProfileSkillsSuggestCreate: (params: RequestParams = {}) =>
            this.request<EntitiesSuggestNewSkillsResponse, any>({
                path: `/api/v1/profile/skills/suggest`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags profile
         * @name V1ProfileSuggestCertificatesCreate
         * @summary suggests new certificates for the user to get
         * @request POST:/api/v1/profile/suggest/certificates
         */
        v1ProfileSuggestCertificatesCreate: (params: RequestParams = {}) =>
            this.request<EntitiesSuggestNewCertificatesResponse, any>({
                path: `/api/v1/profile/suggest/certificates`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1SignupEmailCreate
         * @summary SignUpEmail
         * @request POST:/api/v1/signup/email
         */
        v1SignupEmailCreate: (
            request: EntitiesSignUpEmailRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/signup/email`,
                method: 'POST',
                body: request,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1SignupPasswordCreate
         * @summary SignUpPassword
         * @request POST:/api/v1/signup/password
         */
        v1SignupPasswordCreate: (
            request: EntitiesSignUpPasswordRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/signup/password`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags chat
         * @name V1TtsCreate
         * @summary TTS
         * @request POST:/api/v1/tts
         */
        v1TtsCreate: (
            request: EntitiesTTSRequest,
            params: RequestParams = {}
        ) =>
            this.request<string, any>({
                path: `/api/v1/tts`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserFilesUpdate
         * @summary UploadUserFile
         * @request PUT:/api/v1/user/files
         */
        v1UserFilesUpdate: (
            data: {
                /**
                 * The file
                 * @format binary
                 */
                file: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<string, any>({
                path: `/api/v1/user/files`,
                method: 'PUT',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserFilesDownloadDetail
         * @summary DownloadUserFile
         * @request GET:/api/v1/user/files/{fileId}/download
         */
        v1UserFilesDownloadDetail: (
            fileId: string,
            params: RequestParams = {}
        ) =>
            this.request<number[], any>({
                path: `/api/v1/user/files/${fileId}/download`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserFilesDownloadDetail2
         * @summary DownloadFile
         * @request GET:/api/v1/user/files/{userId}/{fileId}/download
         * @originalName v1UserFilesDownloadDetail
         * @duplicate
         */
        v1UserFilesDownloadDetail2: (
            fileId: string,
            userId: string,
            params: RequestParams = {}
        ) =>
            this.request<number[], any>({
                path: `/api/v1/user/files/${userId}/${fileId}/download`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserForgetCreate
         * @summary ForgetPassword
         * @request POST:/api/v1/user/forget
         */
        v1UserForgetCreate: (
            request: EntitiesSignUpEmailRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/user/forget`,
                method: 'POST',
                body: request,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserMeList
         * @summary GetMe
         * @request GET:/api/v1/user/me
         */
        v1UserMeList: (params: RequestParams = {}) =>
            this.request<EntitiesGetMeResponse, any>({
                path: `/api/v1/user/me`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserMeCreate
         * @summary UpdateMe
         * @request POST:/api/v1/user/me
         */
        v1UserMeCreate: (
            request: EntitiesUpdateMeRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/user/me`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserMeDelete
         * @summary DeleteAccount
         * @request DELETE:/api/v1/user/me
         */
        v1UserMeDelete: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/user/me`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UserPasswordCreate
         * @summary ChangePassword
         * @request POST:/api/v1/user/password
         */
        v1UserPasswordCreate: (
            request: EntitiesChangePasswordRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/user/password`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags ws
         * @name V1WsList
         * @summary RegisterWS
         * @request GET:/api/v1/ws
         */
        v1WsList: (
            request: EntitiesRequestMessage,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesResponseMessage, any>({
                path: `/api/v1/ws`,
                method: 'GET',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
}
